import React from 'react'

import PropTypes from 'prop-types'

import { CardContent, Grid } from '@material-ui/core'
import OrgCard from './OrgCard/OrgCard'
import Pagination from '../../../../UI/Pagination/Pagination'
import PleaseFilter from '../../../../PleaseFilter/PleaseFilter'

const cardContainer = ({
  orgRecords,
  copyButtonClicked,
  pagination,
  pageChanged,
  perPageChanged,
  selectedOrgs,
  selectedResults,
  orgCheckboxChanged,
  deleteButtonClicked,
  filtered,
  pagePermission
}) => {
  const cards = orgRecords.map(record => (
    <OrgCard
      key={record.org_id}
      recordData={record}
      copyButtonClicked={() => copyButtonClicked(record.result_id)}
      actionButtonDisabled={!record.result_id}
      orgCheckboxChanged={() => orgCheckboxChanged(record.org_id, record.result_id)}
      deleteButtonClicked={() => deleteButtonClicked(record.result_id)}
      checked={selectedOrgs.includes(record.org_id) || selectedResults.includes(record.result_id)}
      pagePermission={pagePermission}
    />
  ))
  let content = <PleaseFilter />
  if (filtered) {
    content = (
      <React.Fragment>
        <Grid container spacing={1} justify={'flex-start'}>
          {cards}
        </Grid>
        <Pagination
          pagination={pagination}
          pageChanged={pageChanged}
          perPageChanged={perPageChanged}
        />
      </React.Fragment>
    )
  }

  return <CardContent>{content}</CardContent>
}

cardContainer.propTypes = {
  orgRecords: PropTypes.array.isRequired
}

export default cardContainer
